import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationCircle, faCheckCircle } from '@fortawesome/pro-regular-svg-icons';
import classNames from 'classnames';
import React from 'react';
import { Text } from '../../atoms/Text/Text';
import './DefaultErrorOverlay.scss';

type DefaultErrorOverlayProps = {
  children?: React.ReactNode;
  title: string;
  description: React.ReactNode;
  error?: boolean;
};

export const DefaultErrorOverlay: React.FC<DefaultErrorOverlayProps> = ({
  children,
  title,
  description,
  error = true,
}: DefaultErrorOverlayProps) => {
  return (
    <div className="default-error-overlay">
      <FontAwesomeIcon
        icon={error ? faExclamationCircle : faCheckCircle}
        className={classNames('default-error-overlay__icon', {
          'default-error-overlay__icon--success': !error,
        })}
      />
      <Text
        className={classNames('default-error-overlay__h1', {
          'default-error-overlay__h1--success': !error,
        })}
      >
        {title}
      </Text>
      <Text className="default-error-overlay__detail">{description}</Text>
      {children}
    </div>
  );
};
